export enum ButtonStyleEnum
{
    okOnly = "okOnly",
    okCancel = "okCancel",
    yesNo = "yesNo",
    yesNoCancel = "yesNoCancel",
    retryCancel = "retryCancel",
    abortRetryIgnore = "abortRetryIgnore",
    cancelOnly = "cancelOnly",
}